// src/modules/clientes/view/client-gallery/components/GalleryToolbar.tsx
import React from 'react';
import { Image, Video } from 'lucide-react';

type Props = {
    uploading: boolean;
    onOpenCamera: () => void;
    onPickImages: () => void;
    onPickVideos: () => void;
};

export function GalleryToolbar({ uploading, onPickImages, onPickVideos }: Props) {
    return (
        <div className="flex shrink-0 items-center gap-3">
            {uploading && <span className="loading loading-spinner loading-xs text-base-content/50" aria-label="Enviando" />}

            <button type="button" className="sf-link" onClick={onPickImages} disabled={uploading}>
                <Image aria-hidden />
                Foto
            </button>

            <button type="button" className="sf-link" onClick={onPickVideos} disabled={uploading}>
                <Video aria-hidden />
                Vídeo
            </button>
        </div>
    );
}
